import { render, staticRenderFns } from "./RegisterEmail.vue?vue&type=template&id=71a8159c&scoped=true"
import script from "./RegisterEmail.vue?vue&type=script&lang=js"
export * from "./RegisterEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8159c",
  null
  
)

export default component.exports